(function()
{
	"use strict";

	function TitleView()
	{
		this.View_constructor();

		this.build();
	}

	var p = createjs.extend(TitleView, cm.View);

	p.build = function()
	{
		this.width = cm.app.display.width * 0.5;
		if(this.width> 640){
			this.width = 640;
		}

		cm.main.garbageToCollect.shuffle();
		var background = new cjs.Bitmap(cm.Assets.lib.titlebackground).center();
		this.playbtn = new cjs.Sprite(cm.Assets.lib.titleSS, "play-btn").center();
		this.enterPressed = false;

		this.playbtnbg = new cjs.Sprite(cm.Assets.lib.titleSS, "title-play-btn-bg").set({name:"playbtnbg", x: 330, y: 200, placeArrow: "up"}).center();
		this.playbtn.set({x:330, y:this.playbtnbg.y});

		this.skipbg = new cjs.Sprite(cm.Assets.lib.titleSS, "skip-bg").set({name:"skipbg", x: this.width-150, y: 600, placeArrow: "down"}).center();
		this.skipbtn = new cjs.Sprite(cm.Assets.lib.titleSS, "skip-btn").set({name:"skipbtn", x: this.width-150, y: 580}).center();

		var titleship = new cjs.Sprite(cm.Assets.lib.titleSS, "title-ship").set({name:"titleship", x: -302, y: 150}).center();
		var titlebanana = new cjs.Sprite(cm.Assets.lib.titleSS, "title-banana").set({name:"titlebanana", x:-408, y: -318}).center();
		var logo = new cjs.Sprite(cm.Assets.lib.titleSS, "title-logo").set({name:"logo", y: -185}).center();
		var titlekettle = new cjs.Sprite(cm.Assets.lib.titleSS, "title-kettle").set({name:"titlekettle", x: -448, y: -133}).center();
		var titlemilk = new cjs.Sprite(cm.Assets.lib.titleSS, "title-milk").set({name:"titlemilk", x: 112, y:70}).center();
		var titleplasticring = new cjs.Sprite(cm.Assets.lib.titleSS, "title-plastic-ring").set({name:"titleplasticring", x: 473, y: 8}).center();
		var titlewaterbottle = new cjs.Sprite(cm.Assets.lib.titleSS, "title-water-bottle").set({name:"titlewaterbottle", x: 290, y: -20}).center();
		this.keyNav = new cm.KeyBoardNav();
		this.keyNav.navArrow = this.navArrow = new cjs.Sprite(cm.Assets.lib.titleSS, "sort-home-btn").set({visible:false}).center();
		this.keyNav.buttons.push(this.playbtnbg, this.skipbg);
		this.checkCCSettings();
		this.addChild(
			background,
			this.playbtnbg,
			this.playbtn,
			titleship,
			titlebanana,
			logo,
			titlekettle,
			titlemilk,
			titleplasticring,
			titlewaterbottle,
			this.navArrow
		);
		cm.ViewControl.transitionOverlay.addChildAt(this.skipbg, 0);
		cm.ViewControl.transitionOverlay.addChildAt(this.skipbtn,1);
		this.floatingItems = [
			titleship,
			titlebanana,
			titlekettle,
			titlemilk,
			titleplasticring,
			titlewaterbottle
		];
		this.loopFloat();
		cm.main.preloadVideo();

	};

	p.checkCCSettings = function()
	{
		var shipSettings = localStorage.getItem('shipSettings');

		if(shipSettings)
			cjs.Tween.get(this).wait(2000).call(this.isCaptionsOn, [shipSettings], this);

	};

	p.isCaptionsOn = function(shipSettings)
	{
		var settings = JSON.parse(shipSettings);
			if (app.container.connected !== true)
				app.captions.mute = settings.ccSettings;
	};

	p.start = function()
	{
		this.View_start();
		if(!cm.Device.mobile)
			app.voPlayer.play([1000,"vo-185"]);
		else
			app.voPlayer.play([1000,"vo-119"]);


	};

	p.playVideo = function()
	{
		cjs.Tween.get(this).to({alpha:0}, 500).set({enterPressed:false});
		cjs.Tween.get(this.playbtnbg).wait(500).set({visible:false});
		cjs.Tween.get(this.skipbg).to({y:175}, 250, cjs.Ease.backOut);
		cjs.Tween.get(this.skipbtn).to({y:172}, 250, cjs.Ease.backOut);
		cm.main.videoPlayer.play(this.goToView.bind(this));
		cm.main.introVideoPlayed = true;
		cm.ViewControl.transitionOverlay.addChild(this.navArrow);
		app.on("paused", this.pauseVideo.bind(this));
		app.on("resumed", this.resumeVideo.bind(this));


		// cjs.Tween.get(this.playbtnbg).to({y:1000}, 250, cjs.Ease.backIn);
		// cjs.Tween.get(this.playbtn).to({y:1000}, 250, cjs.Ease.backIn);
	};

	p.muteVideo =  function()
	{
		cm.main.videoPlayer.muteVideoSound();
	};

	p.resumeVideo = function()
	{
		if(cm.main.videoPlayer.isVisible){
			cm.main.videoPlayer.video.play();
		}
	};

	p.pauseVideo = function(){
		cm.main.videoPlayer.pause();
	};

	p.skipVideo = function()
	{
		cm.main.videoPlayer.pause(true);
		this.goToView();
	};

	p.removeSkipBtn = function()
	{
		cm.ViewControl.transitionOverlay.removeChild(this.skipbg);
		cm.ViewControl.transitionOverlay.removeChild(this.skipbtn);
	};

	p.loopFloat = function()
	{
		for (var i = 0, l = this.floatingItems.length; i < l; i++) {
		   var item = this.floatingItems[i];
		   item.snapToPixel = false;
		   var plusOrMinus = Math.random() < 0.5 ? -1 : 1;
		   cjs.Tween.get(item, {loop: true})
		   .to({y:item.y + 20 * plusOrMinus}, 3000, cjs.Ease.quadInOut)
		   .to({y:item.y}, 3000, cjs.Ease.quadInOut);
		}
	};

	p.animateIn = function()
	{
		return 0;
	};

	p.animateOut = function()
	{
		return 2000;

	};

	p.keyNavHandle = function(button)
	{

		switch(button.name){
			case "playbtnbg":
				this.setupVideo();
				this.playbtnbg.removeAllEventListeners();
			break;
			case "skipbg":
				this.skipVideo();
			break;
		}
	};

	p.setupVideo = function()
	{
		/** Store the video player on the app so it can be accessed any scene */

		this.playVideo();
	};

	p.buttonHandler = function (e)
	{
		if (e.type === "mouseover") {

			if (e.target.name === "playbtnbg") {
				app.voPlayer.play("vo-120");
				cjs.Tween.get(this.playbtn)
				.to({ scaleX: 1.1, scaleY: 1.1 }, 180, cjs.Ease.sineIn);
			}else{
				app.voPlayer.play("vo-121");
				cjs.Tween.get(this.skipbtn)
				.to({ scaleX: 1.1, scaleY: 1.1 }, 180, cjs.Ease.sineIn);
			}
		}

		if (e.type === "mouseout") {
			if (e.target.name === "playbtnbg") {
				cjs.Tween.get(this.playbtn)
				.to({ scaleX: 1, scaleY: 1 }, 180, cjs.Ease.sineIn);
			}else{
				cjs.Tween.get(this.skipbtn)
				.to({ scaleX: 1, scaleY: 1 }, 180, cjs.Ease.sineIn);
			}
		}

		if (e.type === "mousedown") {
			if (e.target.name === "playbtnbg") {
				cjs.Tween.get(this.playbtn)
				.to({ scaleX: 0.8, scaleY: 0.8 }, 180, cjs.Ease.sineIn);
			}else{
				cjs.Tween.get(this.skipbtn)
				.to({ scaleX: 0.8, scaleY: 0.8 }, 180, cjs.Ease.sineIn);
			}
		}
		if (e.type === "click") {
			cm.app.sound.play("click-1");
			if (e.target.name === "playbtnbg") {
				this.setupVideo();
				cjs.Tween.get(this.playbtn)
				.to({ scaleX: 1, scaleY: 1 }, 240, cjs.Ease.backOut);
				e.target.removeAllEventListeners();
			}
			if (e.target.name === "skipbg") {

				cjs.Tween.get(this.skipbtn)
				.to({ scaleX: 1, scaleY: 1 }, 240, cjs.Ease.backOut)
				.call(this.skipVideo, null, this);
				e.target.removeAllEventListeners();
			}
		}

	};

	p.goToView = function()
	{

		cm.main.videoPlayer.video.classList.add("fadeOut");
		cm.main.videoPlayer.isVisible = false;
		cjs.Tween.get(this.skipbg).to({y:600}, 250, cjs.Ease.backIn);
		cjs.Tween.get(this.skipbtn).to({y:600}, 250, cjs.Ease.backIn).call(this.removeSkipBtn, null, this);
		cm.main.callTitleLoader();
	};

	p.setActive = function( bool )
	{
		if(bool)
		{
			this.playbtnbg.on("mousedown", this.buttonHandler, this);
			this.playbtnbg.on("click", this.buttonHandler, this);
			this.playbtnbg.on("mouseover", this.buttonHandler, this);
			this.playbtnbg.on("mouseout", this.buttonHandler, this);

			this.skipbg.on("mousedown", this.buttonHandler, this);
			this.skipbg.on("click", this.buttonHandler, this);
			this.skipbg.on("mouseover", this.buttonHandler, this);
			this.skipbg.on("mouseout", this.buttonHandler, this);
		}
		else {
			this.keyNav.removeEventsOnButtons();
		}
		app.container.on('soundMuted', this.muteVideo.bind(this));
	};

	p.handleKeyPress = function()
	{
		if(this.enterPressed){return;}
		this.enterPressed = true;
		if(cm.Keyboard.state("enterKey")){
			if(this.playbtnbg.visible){
				app.voPlayer.stop();
				this.keyNavHandle(this.playbtnbg);
			}
			else{
				this.keyNavHandle(this.skipbg);
			}
		}
	};

	p.resize = function()
	{
		this.width = cm.app.display.width * 0.5;
		if(this.width> 640){
			this.width = 640;
		}
		this.skipbg.x = this.width-100;
		this.skipbtn.x = this.width-100;
	};

	p.update = function()
	{
		if(cm.Keyboard){
			this.handleKeyPress();
			this.keyNav.keyCheck();
			cm.Keyboard.clearPressed();
		}
	};

	p.destroy = function()
	{
		this.View_destroy();
	};

	cm.View.TitleView = cjs.promote(TitleView, "View");
})();